module.exports = __webpack_public_path__ + "static/media/icon_eye_open.da594bbb.png";